import React, { ReactElement } from 'react'
import { useAppSelector } from 'store/hooks'
import QueryFilterDropdownContent from './QueryFilterDropdownContent'
import QueryFilterDropdown from './QueryFilterDropdown'
import { QueriesFilterMenuType } from '../FiltersContainer'
import { useGetDeviceClientsQuery, useGetDevicesQuery } from 'store/api/devices'
import sortBy from 'lodash/sortBy'

export default function ClientsDropdown(): ReactElement {
  const filterParameters = useAppSelector(s => s.activityLog.queryFilters)
  const { data: devicesData } = useGetDevicesQuery('')

  const selectedEndpoint = devicesData?.devices?.find(
    device => filterParameters[QueriesFilterMenuType.ENDPOINT] === device.PK,
  )
  const { data: clientsData, isFetching } = useGetDeviceClientsQuery(selectedEndpoint?.PK, {
    skip: !selectedEndpoint?.PK,
  })

  const selectedClient = clientsData?.clients?.find(
    client => filterParameters[QueriesFilterMenuType.CLIENT] === client.id,
  )

  return (
    <QueryFilterDropdown
      isDisabled={!selectedEndpoint?.PK || !clientsData?.clients?.length}
      selectedValue={(selectedClient?.alias ?? selectedClient?.host) || 'Clients'}
      type={QueriesFilterMenuType.CLIENT}
      isLoading={isFetching}
    >
      <QueryFilterDropdownContent
        type={QueriesFilterMenuType.CLIENT}
        clients={sortBy(clientsData?.clients || [], [o => o.host.toLowerCase()])}
        maxHeight="29.5rem"
        ignoreActionIfClickOnSelectedOption
      />
    </QueryFilterDropdown>
  )
}
